<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="info-card">
            <div class="info-icon user-icon">
              <i class="el-icon-s-custom" />
            </div>
            <div class="info-content">
              <div class="info-label">当前用户</div>
              <div class="info-value">{{ username }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="info-card">
            <div class="info-icon time-icon">
              <i class="el-icon-user-solid" />
            </div>
            <div class="info-content">
              <div class="info-label">当前角色</div>
              <div class="info-value">{{ rolename }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="info-card">
            <div class="info-icon server-icon">
              <i class="el-icon-s-promotion" />
            </div>
            <div class="info-content">
              <div class="info-label">服务器状态</div>
              <div class="info-value">运行中</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="welcome-card" shadow="never">
      <div slot="header">
        <span>系统公告</span>
      </div>
      <p>欢迎使用 SINCEGAME SSO。</p>
      <p>您可以通过左侧菜单访问各功能模块。</p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      username: localStorage.getItem('sso_user') || '',
      rolename: localStorage.getItem('sso_role') || '',
    };
  }
};
</script>

<style scoped>
.dashboard-container {
  padding: 10px;
}
.info-card {
  display: flex;
  align-items: center;
}
.info-icon {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin-right: 16px;
}
.user-icon {
  background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
}
.time-icon {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
}
.server-icon {
  background: linear-gradient(135deg, #E6A23C 0%, #ebb563 100%);
}
.info-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}
.info-value {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}
.welcome-card {
  margin-top: 20px;
}
.welcome-card p {
  color: #606266;
  line-height: 1.8;
}
</style>